import { z } from "zod";
import { npdCalculationResultParameterDtoSchema } from "./npd-calculation-result-parameter.schema";
export const npdCalculationResultDtoSchema = z.object({
    parameters: z.array(npdCalculationResultParameterDtoSchema),
});
